export default __webpack_public_path__ + "img/f2cdf18ce0916a0cb952cda9b8190e9b.svg";